import { Paper, Stack, TextInput } from "@mantine/core";
import { profileApi } from "apis/profileApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { Profile, UpdateProfileRequest } from "constants/types/profile";
import { useFormik } from "formik";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import ProfileAvatarInput from "./components/ProfileAvatarInput/ProfileAvatarInput";
import { profileValidationSchema } from "./config";

export const PROFILE_FORM_ID = "profile-form";

interface ProfileModalProps {
  profile: Profile;
  onClose?: () => void;
  mutate?: () => void;
}

const ProfileModal: FC<ProfileModalProps> = ({ profile, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const avatarLabel = profile.fullname?.charAt(0)?.toUpperCase() ?? "U";

  const formik = useFormik<UpdateProfileRequest>({
    initialValues: {
      fullname: profile.fullname,
      phone: profile.phone ?? "",
    },
    validationSchema: profileValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await profileApi.update(values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật thông tin thành công" });
          mutate?.();
          onClose?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Cập nhật thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <Stack gap="sm">
          <ProfileAvatarInput
            avatarKey={profile.avatarKey}
            avatarLabel={avatarLabel}
            onUploaded={() => mutate?.()}
          />
          <form id={PROFILE_FORM_ID} onSubmit={formik.handleSubmit}>
            <Stack gap="sm">
              <TextInput label="Tên đăng nhập" value={profile.username} disabled />
              <TextInput
                label="Vai trò"
                value={profile.roles.join(", ")}
                disabled
              />
              <TextInput
                label="Họ và tên"
                placeholder="Nhập họ và tên"
                name="fullname"
                value={formik.values.fullname}
                onChange={formik.handleChange}
                error={formik.errors.fullname}
              />
              <TextInput
                label="Số điện thoại"
                placeholder="Nhập số điện thoại"
                name="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                error={formik.errors.phone}
              />
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Loading>
  );
};

export default ProfileModal;
